module.exports = __webpack_public_path__ + "static/img/login-background.7f04cd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b122/login-background.png
// module id = kaMZ
// module chunks = 1